<template>
    <b-popover
        v-bind="$props"
    >
        <slot name="title" slot="title" />
        <slot />
    </b-popover>
</template>

<script>
import { BPopover } from 'bootstrap-vue'

export default {
    components: { BPopover },
    props: {
        customClass: { type: String },
        placement: { type: String, default: 'right' },
        target: { type: String },
        title: { type: String },
        triggers: { type: String, default: 'click' },
    },
}
</script>